import { getDefaultLocale } from '../../infrastructure/utilities';

const LOCALE_CURRENCY_MAP = {
  'en-US': 'USD',
  'es-ES': 'EUR',
  'es-PE': 'PEN',
};

const getCurrencyFromLocale = (locale) => {
  if (LOCALE_CURRENCY_MAP[locale]) {
    return LOCALE_CURRENCY_MAP[locale];
  }

  const language = locale.split('-')[0];
  const fallbackLocale = Object.keys(LOCALE_CURRENCY_MAP).find((key) =>
    key.startsWith(`${language}-`),
  );

  return fallbackLocale ? LOCALE_CURRENCY_MAP[fallbackLocale] : LOCALE_CURRENCY_MAP['en-US'];
};

class CurrencyFormatter {
  constructor() {
    const locale = getDefaultLocale();

    const [lang, country] = locale.toLowerCase().split('-');
    const normalizedLocale = `${lang}-${country.toUpperCase()}`;

    this.defaultLocale = normalizedLocale;
    this.defaultCurrency = getCurrencyFromLocale(this.defaultLocale);
  }

  format(amount, currency, options = {}) {
    const defaultCurrency = currency ?? this.defaultCurrency;
    const defaultLocale = currency
      ? require('../../domain')?.reverseEnumerator?.(LOCALE_CURRENCY_MAP)?.[currency]
      : this.defaultLocale;

    return new Intl.NumberFormat(defaultLocale, {
      style: 'currency',
      currency: defaultCurrency,
      ...options,
    }).format(amount);
  }

  setDefaults(locale, currency = null) {
    this.defaultLocale = locale;
    this.defaultCurrency = currency ?? getCurrencyFromLocale(locale);
    return this;
  }
}

let instance = null;
CurrencyFormatter.getInstance = () => {
  if (!instance) instance = new CurrencyFormatter();
  return instance;
};

const formatter = CurrencyFormatter.getInstance();
const formatCurrency = (amount, currency = null, options = {}) => {
  return formatter.format(amount, currency, options);
};

export default formatCurrency;
